import React,{useState,useEffect} from 'react'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Button,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
    ButtonDropdown,
} from "reactstrap";
import  AsyncCreatable from 'react-select/creatable';
import { useSelector,useDispatch } from 'react-redux';
import {SUPPORT_PHONE_RAW} from "../../constants/defaultValues";
import {formatPhoneNumber} from "react-phone-number-input";

export default function NewMessageModal({isVisible=true,toggle}) {
  

  return (
    <Modal isOpen={isVisible} toggle={toggle} >
            <ModalHeader>
                Support
            </ModalHeader>
            <ModalBody>
            We're sorry that you are experiencing difficulties and would love to help you resolve your issue as quickly as possible. Please text or call us at  <a href={`tel:${SUPPORT_PHONE_RAW}`}>{formatPhoneNumber(SUPPORT_PHONE_RAW)}</a>.<br/><br/>
            You may also email us at info@getinca.com. <br/><br/>
            Thank you!
    
        </ModalBody>
          
        <ModalFooter>
            <Button color="secondary" 
             onClick={toggle}
            >
                Close
            </Button>
        </ModalFooter>
    </Modal>
  )
}
